import { ControlIcons } from 'owa-control-icons';
import DetailsIcons from 'txp-data/lib/schema/configSchema/DetailsIcons';

/**
 * Returns the icons required to display TXP calendar peeks for all entities
 */
export function createCalendarTxpDetailsIcons(): DetailsIcons {
    return {
        accept: ControlIcons.Accept,
        airPlane: ControlIcons.Airplane,
        airPlaneSolid: ControlIcons.AirplaneSolid,
        appointment: ControlIcons.Stopwatch,
        arrivals: ControlIcons.Arrivals,
        building: ControlIcons.CityNext,
        clock: ControlIcons.Clock,
        contact: ControlIcons.Contact,
        deliveryTruck: ControlIcons.DeliveryTruck,
        edit: ControlIcons.Edit,
        location: ControlIcons.Poi,
        mail: ControlIcons.Mail,
        money: ControlIcons.Money,
        parkingLocation: ControlIcons.ParkingLocation,
        paymentCard: ControlIcons.PaymentCard,
        phone: ControlIcons.Phone,
        ticket: ControlIcons.Ticket,
        warning: ControlIcons.Warning,
    };
}

/**
 * Returns the icons required to display TXP mail cards for all entities
 */
export function createMailTxpDetailsIcons(): DetailsIcons {
    return {
        accept: ControlIcons.Accept,
        add: ControlIcons.Add,
        airPlane: ControlIcons.Airplane,
        airPlaneSolid: ControlIcons.AirplaneSolid,
        appointment: ControlIcons.Stopwatch,
        calendar: ControlIcons.Calendar,
        car: ControlIcons.Car,
        deliveryTruck: ControlIcons.DeliveryTruck,
        clock: ControlIcons.Clock,
        contact: ControlIcons.Contact,
        phone: ControlIcons.Phone,
        eatDrink: ControlIcons.EatDrink,
        edit: ControlIcons.Edit,
        event: ControlIcons.Ticket,
        location: ControlIcons.Poi,
        hotel: ControlIcons.Hotel,
        paymentCard: ControlIcons.PaymentCard,
    };
}

/**
 * Returns the icons required to display TXP action buttons in calendar for all entities
 */
export function createActionButtonTxpDetailsIcons(): DetailsIcons {
    return {
        accept: ControlIcons.Accept,
        airPlane: ControlIcons.Airplane,
        appointment: ControlIcons.Stopwatch,
        deliveryTruck: ControlIcons.DeliveryTruck,
        edit: ControlIcons.Edit,
        paymentCard: ControlIcons.PaymentCard,
        mail: ControlIcons.Mail,
    };
}
